import { cookieReducers } from '@godaddy/gasket-cookies';
import { Reducer } from 'redux';
import { endpoints } from './endpoints';
import { VisitorSlice } from './slices/VisitorSlice';
import { EnvironmentSlice } from './slices/EnvironmentSlice';

const slices = [VisitorSlice, EnvironmentSlice];

export const reducers = {
  ...['config', 'hivemind', 'analytics'].reduce(
    (r: Record<string, Reducer>, key) => ({
      ...r,
      [key]: (f: any) => f || null
    }),
    {}
  ),
  ...slices
    .filter(f => 'reducer' in f && 'name' in f)
    .reduce(
      (r, f) => ({
        ...r,
        [f.name]: f.reducer
      }),
      {}
    ),
  ...cookieReducers,
  ...endpoints
    .filter(f => 'reducer' in f && 'reducerPath' in f)
    .reduce(
      (r, f) => ({
        ...r,
        [f.reducerPath]: f.reducer
      }),
      {}
    )
};
